export const CyphlensImageVerificationStatus = {
  success: 'SUCCESS',
  expired: 'EXPIRED',
  pending: 'PENDING',
};
